import React, { useState, FC, ImgHTMLAttributes, useEffect } from 'react'
import defaultImg from 'src/pc/assets/images/DDImage/defaultImg.png'
import styled from 'styled-components'

type IDDImage = {
  className?: string
} & ImgHTMLAttributes<HTMLImageElement>
/**
 * @class DDImage
 * @description 提供图片loading状态的高阶组件
 * @param {prop} src 图片路径
 * @param {prop} className 接受外部定义class
 * @param {prop} style 接受外部定义样式
 * @param {state} loading 控制loading状态是否存在
 */
const DDImage: FC<IDDImage> = ({ src, className, ...otherProps }) => {
  const [loading, setLoading] = useState<boolean>(true)
  useEffect(() => {
    let img: HTMLImageElement | null = document.createElement('img')
    img.onload = () => {
      setLoading(false)
    }
    img.src = src || ''
    return () => {
      if (img) {
        img.onload = null
      }
      img = null
    }
  }, [src])

  if (loading) {
    return (
      <StyledImageMarkContainer>
        <img className="defaultImg" src={defaultImg} />
      </StyledImageMarkContainer>
    )
  }

  return <StyledImagesContainer className={className} src={src} draggable={false} {...otherProps} />
}

const StyledImageMarkContainer = styled.div`
  background: #121212;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  .defaultImg {
    width: 38px !important;
    height: 35px !important;
  }
`

const StyledImagesContainer = styled.img`
  opacity: 1;
  animation: 0.8s enlarge;
  @keyframes enlarge {
    0% {
      opacity: 0;
    }
    100% {
      transform: 1;
    }
  }
`
export default DDImage
